import { type EngineStateBase } from '@blaze-runtime/engine-data-access';

/** The layout fields an undo/redo step captures and restores. */
export type LayoutSnapshot = Partial<EngineStateBase>;

export interface HistoryExtras {
  past: LayoutSnapshot[];
  snapshot?: LayoutSnapshot;
  future: LayoutSnapshot[];
  /** True from the moment an undo/redo is requested until the layout is restored. */
  isRestoring?: boolean;
}

/** The undo/redo fields this library adds to the `engine` slice. */
export interface HistorySlice {
  history: HistoryExtras;
}

/**
 * The engine slice as the history handlers see it: the engine's own fields, plus the history ones
 * when this library's extension is registered.
 */
export type HistoryEngineState = EngineStateBase & Partial<HistorySlice>;

export const initialHistorySlice: HistorySlice = {
  history: {
    past: [],
    snapshot: undefined,
    future: [],
    isRestoring: false,
  },
};
